<template>
	<Poptip
        confirm
		:title="title"
		:placement="placement"
		:transfer="transfer"
		v-model="visible"
		@on-ok="ok"
		@click.native="(e) =>e.stopPropagation()"
        @on-cancel="cancel">
        <Button :type="type" :size="size" v-bind="$attrs" @click="showPoptip">
        	{{text}}
			<common-icon :type="icon" :size="iconSize" v-if="icon"></common-icon>
		</Button>
    </Poptip>
</template>
	
<script>
	import CommonIcon from '../common-icon'
	import Poptip from '../poptip'

	export default {
		components:{
			CommonIcon,
			Poptip
		},

		inheritAttrs: false,

		props: {
			title: {
				type: String,
				default: ""
			},
			text: {
				type: String,
				default: ""
			},
			ok:{
				type: Function,
				default: () => {}
			},
			cancel:{
				type: Function,
				default: () => {}
			},
			placement:{
				type: String,
				default: "top"
			},

			icon:{
				type:String,
				default:''
			},
			iconSize:{
				type:Number,
				default:16
			},

			type: {
				type:String,
				default: 'text'
			},
			size: {
				type: String,
				default: 'small'
			},
			transfer: {
				type: Boolean,
				default: false
			}
		},
		data(){
			return {
				visible:false
			}
		},
		methods:{
			showPoptip(e){
				e.stopPropagation()
				this.visible = true
			}
		}
	}
</script>